import { env } from "@/config/env";

type ResolveBillingHrefArgs = {
  email: string | undefined;
  isKickstarter: boolean;
  isSubscriptionActive: boolean | undefined;
};

export function resolveBillingHref({
  email,
  isKickstarter,
  isSubscriptionActive,
}: ResolveBillingHrefArgs): string {
  if (isKickstarter || !isSubscriptionActive) {
    return "/pricing";
  }

  return `${env.VITE_BILLING_URL}${env.VITE_STRIPE_BILLING_TOKEN}?prefilled_email=${encodeURIComponent(email ?? "")}`;
}
